<template>
  <div>    
    <footer class="">
    <div class="text-center">
      <div class="row justify-content-center header pb-5 pt-5">
        <div class="col-md-12 col-12">  
          <a href="https://www.elnuevodia.com/" target="_blank">
            <img class="brand-footer" src="@/assets/main-logo.png" height="75px" alt="image" />
          </a>
        </div>
        <div class="col-md-12 col-12">
          <SocialSharing/>
        </div>
      </div>
    </div>
    </footer>
  </div>
</template>

<script>

import SocialSharing from '@/components/SocialSharing.vue'

export default {
  name: 'Footer',
  components: {
    SocialSharing
  }
}
</script>
